<template>
    <div v-if="layout" :style="{backgroundColor:layout?.pageBackground?.color}">
     

        <!-- Main Content -->
        <div class="main-container" :style="{backgroundColor:layout?.pageBackground?.color}">
            <!-- Page Header -->
            <div class="page-header">
                <h1 v-if="layout.box1?.heading" 
                    class="page-title" 
                    :style="getTextStyle(layout.box1.heading)">
                    {{ layout.box1.heading.text }}
                </h1>
                
                <p v-if="layout.box2?.subheading" 
                   class="page-subtitle" 
                   :style="getTextStyle(layout.box2.subheading)">
                    {{ layout.box2.subheading.text }}
                </p>
            </div>

            <!-- Main Image -->
            <div class="image-section" v-if="layout.box3?.image">
                <img v-if="layout.box3.image.preview" 
                     :src="layout.box3.image.preview" 
                     alt="Order Process Image"
                     class="main-image" />
                <div v-else class="image-placeholder">
                    Hands using laptop and phone - Online Ordering Image
                </div>
            </div>

            <!-- Steps Section -->
            <div class="steps-section" v-if="layout.box4?.orderDetails">
                <div class="order-details" v-html="layout.box4.orderDetails.text"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PageLayoutSix",
    props: {
        layout: {
            type: Object,
            required: true
        }
    },
    methods: {
        getTextStyle(textConfig) {
            return {
                fontSize: textConfig.fontSize ? `${textConfig.fontSize}px` : '16px',
                color: textConfig.color || '#333333',
                backgroundColor: textConfig.backgroundColor || 'transparent',
                fontFamily: textConfig.fontFamily || 'Roboto, Arial, sans-serif',
                fontWeight: textConfig.bold ? 'bold' : 'normal'
            };
        },
    }
}
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

/* div.order-details span {
  color: inherit !important;
} */

/* a, h1, h2, h3, p {
  font-weight: 400;
  color: #444;
}

span {
  font-weight: 400;
  color: inherit; 
} */

/* Header Navigation */
.header {
    background-color: #333;
    color: white;
    padding: 15px 0;
    position: sticky;
    top: 0;
    z-index: 100;
}

.nav-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.logo {
    font-size: 24px;
    font-weight: bold;
    color: white;
}

.nav-buttons {
    display: flex;
    gap: 10px;
}

.nav-buttons button {
    background-color: transparent;
    color: white;
    border: 1px solid #666;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
}

.nav-buttons button:hover {
    background-color: #666;
}

.google-btn {
    background-color: #4285f4 !important;
    border-color: #4285f4 !important;
}

.google-btn:hover {
    background-color: #357abd !important;
}
:deep(.order-details ul) {
    list-style-type: disc !important;
    margin-left: 1.5em;
    padding-left: 1em;
}
:deep(.order-details ol) {
    list-style-type: decimal !important;
    margin-left: 1.5em;
    padding-left: 1em;
}
/* Main Content Container */
.main-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 40px 20px;
    background-color: white;
    min-height: calc(100vh - 80px);
}

/* Page Header Section */
.page-header {
    text-align: center;
    margin-bottom: 50px;
}

.page-title {
    font-size: 48px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
    line-height: 1.2;
}

.page-subtitle {
    font-size: 24px;
    color: #666;
    margin-bottom: 40px;
}

/* Image Section */
.image-section {
    text-align: center;
    margin: 50px 0;
}

.main-image {
    max-width: 100%;
    width: 100%;
    height: auto;
    border-radius: 12px;
    /* box-shadow: 0 8px 30px rgba(0,0,0,0.12); */
}

.image-placeholder {
    max-width: 600px;
    width: 100%;
    height: 350px;
    margin: 0 auto;
    background: linear-gradient(45deg, #f0f0f0 25%, transparent 25%),
                linear-gradient(-45deg, #f0f0f0 25%, transparent 25%),
                linear-gradient(45deg, transparent 75%, #f0f0f0 75%),
                linear-gradient(-45deg, transparent 75%, #f0f0f0 75%);
    background-size: 20px 20px;
    background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
    border: 2px dashed #ccc;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
    font-size: 18px;
    box-shadow: 0 8px 30px rgba(0,0,0,0.12);
}

/* Steps Section */
.steps-section {
    max-width: 800px;
    margin: 60px auto 0;
}

.order-details >>> .step-item {
    margin-bottom: 25px;
    font-size: 16px;
    line-height: 1.7;
    color: #444;
}

.order-details >>> .step-number {
    font-weight: bold;
    color: #333;
    margin-right: 10px;
}

.order-details >>> .step-text {
    display: inline;
}

.order-details >>> .or-divider {
    text-align: center;
    margin: 20px 0;
    font-weight: bold;
    color: #666;
    font-size: 18px;
}

.order-details >>> .highlight-text {
    background-color: #f8f9fa;
    padding: 15px;
    border-left: 4px solid #007bff;
    margin: 15px 0;
    border-radius: 4px;
}

.order-details >>> .highlight-text p {
    margin-bottom: 10px;
}

.order-details >>> .contact-email {
    color: #007bff;
    text-decoration: none;
}

.order-details >>> .contact-email:hover {
    text-decoration: underline;
}

/* Page Navigation */
.page-navigation {
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    background-color: rgba(0,0,0,0.8);
    color: white;
    padding: 10px 20px;
    border-radius: 25px;
    font-size: 14px;
    z-index: 50;
}


/* Responsive Design */
@media (max-width: 768px) {
    .nav-container {
        flex-direction: column;
        gap: 15px;
    }

    .main-container {
        padding: 20px 15px;
    }

    .page-title {
        font-size: 36px;
    }

    .page-subtitle {
        font-size: 20px;
    }

    .order-details >>> .step-item {
        font-size: 15px;
    }

    .nav-buttons {
        flex-wrap: wrap;
        justify-content: center;
    }
    .nav-buttons button {
        flex: 1 1 100%;
        margin-bottom: 10px;
    }

    .nav-buttons button:last-child {
        margin-bottom: 0;
    }
    .image-section {
        margin: 30px 0;
    }
    .main-image {
        max-width: 100%;
    }
    .image-placeholder {
        max-width: 100%;
        height: 250px;
    }
    .steps-section {
        margin: 40px auto 0;
    }
}

@media (max-width: 480px) {
    .page-title {
        font-size: 28px;
    }

    .page-subtitle {
        font-size: 18px;
    }

    .order-details >>> .step-item {
        font-size: 14px;
    }
    .page-header h1{
        font-size: 32px !important;
    }
    .page-header p{
        font-size: 18px !important;
    }
   .main-container .steps-section .order-details {
        font-size: 14px !important;
    }
}
</style>